export default {
  common: {
    projectList: "Project list",
    pleaseInputProjectName: "Please input project name",
    pipeline: "Pipeline",
    onhold: "Onhold",
    win: "Win",
    loss: "Loss",
    city: "City",
    amount: "Amount",
    winProbability: "Win Probability",
    registeredOn: "Registerd on",
    updatedOn: "Update on",
    thereAreNoMoreProjectsLeft: "There are no more projects left",

    drafting: "Drafting",
    ready: "Ready",
    shared: "Shared",
    negotiating: "Negotiating",
    secured: "Secured",
    lost: "Lost",
    onhold: "On-hold",

    INITIAL: "ECM report preparing",
    ECM_REPORT_PREPARED: "ECM report pending customer sharing",
    ECM_TO_CUSTOMER: "ECM report sent to customer",
    CUSTOMER_KIV_PROPOSAL: " Customer keep in view proposal",
    CUSTOMER_FUNDED: "Customer confirmed project funded",
    CUSTOMER_PROPOSAL: "Customer negotiating on proposal",
    EA_TO_CUSTOMER: "EA report sent to customer",
    CUSTOMER_ORDERS: "customer orders",
    LOST_TO_COMPETITION: "Lost to competition",
    STATUS_PROJECT: "Status reported in another project",
    IN_ACTIVE: "Project on-hold",
    getProjectInfoFailed: "Get project info failed",
    getCitylistFailed: "Get city list failed",
    cantGetProjectDetails: "Can't get project details",
    noProjectId: "No project id",
    noProjectState: "No project status",
    enterProjectName: "Enter project name",

    noActualEcmQuoted: "No actual ECM quoted"
  },
  projectDlg: {
    newProject: "New project",
    projectName: "Project name",
    projectState: "Project status",
    customer: "Customer",
    address: "Address",
    customerEmail: "Customer E-mail",
    auditDate: "Audit date",
    jobsiteCity: "Jobsite city",
    estimatedEcmQuoted: "Estimated ECM quoted",
    exceptedOrder: "Excepted order date",
    winProbability: "Win probability %",
    saveRetrun: "Save & return",
    saveAudit: "Save & audit",
    statusRemarks: "Status remarks",

    actualEcmQuoted: "Actual ECM quoted",
    actualOrder: "Actual order date"
  }
}



// WEBPACK FOOTER //
// ./src/locale/projectList/en.js